module.exports = __webpack_public_path__ + "img/arrow-narrow-right-black.eafedd92.svg";